import { Alert } from 'antd'
import { useFeatureFlagEnabled, useFeatureFlagVariantKey } from 'posthog-js/react'
import { useTranslation } from 'react-i18next'

interface Props {
  name: string

  active?: JSX.Element
  inactive?: JSX.Element

  variants?: {
    [variant: string]: JSX.Element
  }
}

export function FeatureFlag(props: Props) {
  const { t } = useTranslation()
  const enabled = useFeatureFlagEnabled(props.name)
  const variant = useFeatureFlagVariantKey(props.name)

  if (!props.active && !props.variants) {
    return <Alert message={t('invalid-feature-flag', 'Invalid Feature Flag Variants, either "active" or "variants" are required!')} />
  }

  if (!enabled) {
    return props.inactive || null
  }

  if (typeof variant === 'string' && props.variants && props.variants[variant]) {
    return props.variants[variant]
  }

  return props.active || null
}
